import React from 'react'
import { Field } from 'redux-form/immutable'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import Select from 'app/components/Select'
import { getTimezonesWithGuess } from 'helpers/getTimezonesWithGuess'
import './styles.scss'

const bc = 'select-timezone'

const SelectTimeZones = ({ timezone, t }) => (
  <Field
    name="timezone"
    component={Select}
    options={getTimezonesWithGuess(timezone)}
    getLabel={timezone => `UTC ${moment.tz(timezone.value).format('Z')} ${timezone.name}`}
    getKey={timezone => timezone.name}
    label={t('Time zone')}
    className={bc}
    labelClassName={`${bc}__label`}
    classNameSelectWrapper={`${bc}__select`}
  />
)

export default withTranslation('user')(SelectTimeZones)
